import type { ReactNode } from 'react';

export const symbol_chess_pawn_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M218-80q-24 0-39-17.5T168-138q17-77 68.5-137T363-364q-37-28-58-68.93-21-40.94-21-86.66Q284-577 313-624t80-72q-13-15-19.5-33.63Q367-748.27 367-768q0-47.08 32.94-80.04 32.94-32.96 80-32.96T560-848.04q33 32.96 33 80.04 0 19.73-6 38.37Q581-711 568-696q51 25 79.5 72T676-519.59q0 45.72-21 86.66Q634-392 597-364q75 29 126.5 89T792-138q5 23-10.49 40.5Q766.01-80 742-80H218Zm262-246q-88-1-157 50.5T230-140h501q-24-84-93.5-135.5T480-326Zm.24-60q56.76 0 96.26-39 39.5-39 39.5-96t-39.74-96q-39.73-39-96.5-39-56.76 0-96.26 39.74-39.5 39.73-39.5 96.5 0 56.76 39.74 95.26 39.73 38.5 96.5 38.5Zm37.26-345.73q15.5-14.73 15.5-36.5T517.5-805Q502-820 480-820t-37.5 14.93q-15.5 14.93-15.5 37t15.5 36.57Q458-717 480-717t37.5-14.73ZM480-768Zm0 628Zm0-381Z"
		/>
	</svg>
);
